"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.algeriaTranslations = void 0;
var _types = require("../../../types");
const algeriaTranslations = exports.algeriaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Désolé !',
  [_types.ErrorPageTranslationKey.buttonText]: 'Retour',
  [_types.ErrorPageTranslationKey.text]: 'Cette page est inaccessible pour le moment',
  [_types.ErrorPageTranslationKey.notFound]: "La page que vous essayez d'atteindre ne semble fonctionner",
  [_types.ErrorPageTranslationKey.unauthorized]: "La page à laquelle vous essayez d'accéder est restreinte et vous ne répondez pas à tous les critères.",
  [_types.ErrorPageTranslationKey.contactSupportTeam]: "Veuillez contacter l'équipe d'assistance Oriflame par e-mail :",
  [_types.ErrorPageTranslationKey.rejectedUrl]: "L'URL demandée a été rejetée !"
};
